/** @domain contact -- Phone numbers and work contact fields: phone, mobile, fax, work number, country calling code. */
import { z } from 'zod';
import { createDomainField } from './types';
import { numericWithDashes } from './formatters';

const define = createDomainField('contact');

export const phone = define({
  label: 'Phone Number',
  schema: z.string().regex(/^[0-9-][0-9-]*$/, 'Must contain only digits and dashes'),
  adapterHint: 'text',
  formatter: numericWithDashes,
  displayFormat: 'phone',
});

export const mobile = define({
  label: 'Mobile Number',
  schema: z.string().regex(/^[0-9-][0-9-]*$/, 'Must contain only digits and dashes'),
  adapterHint: 'text',
  formatter: numericWithDashes,
  displayFormat: 'phone',
});

export const fax = define({
  label: 'Fax',
  schema: z.string().regex(/^[0-9-][0-9-]*$/, 'Must contain only digits and dashes'),
  adapterHint: 'text',
  formatter: numericWithDashes,
  displayFormat: 'phone',
});

export const workNumberCode = define({
  label: 'Work Number Code',
  schema: z.string(),
  adapterHint: 'async-select',
  displayFormat: 'text',
});

export const workNumber = define({
  label: 'Work Number',
  schema: z.string().regex(/^[0-9-]*$/, 'Must contain only digits and dashes'),
  adapterHint: 'text',
  controlWidth: 'medium',
  formatter: numericWithDashes,
  displayFormat: 'phone',
});

export const workEmail = define({
  label: 'Work Email',
  schema: z.string().email('Must be a valid email address'),
  adapterHint: 'text',
  controlWidth: 'long',
  displayFormat: 'text',
});

export const homeNumber = define({
  label: 'Home Number',
  schema: z.string().regex(/^[0-9-][0-9-]*$/, 'Must contain only digits and dashes'),
  adapterHint: 'text',
  formatter: numericWithDashes,
  displayFormat: 'phone',
});

export const countryCallingCode = define({
  label: 'Country Code',
  schema: z.string(),
  adapterHint: 'async-select',
  displayFormat: 'text',
});

export const phoneRelaxed = z.string().optional();
